module.exports = __WEBPACK_EXTERNAL_MODULE_100__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 100
// module chunks = 0